import { Observable, Subject } from 'rxjs';

export class CustomEventService<T> {
  private subject = new Subject<T>();

  public publishEvent = (event: T) => this.subject.next(event);

  public getEventAsObservable = (): Observable<T> => this.subject.asObservable();

  public clearEvents = (event: T) => this.subject.next(event);
}
